import esMessages from "../locales/es_FR";

const EsLang = {
  messages: {
    ...esMessages
  },
  locale: "es-FR"
};
export default EsLang;
